import { FC } from 'react';
import styles from './Quote.module.scss';
interface QuoteProps {
  
}
const Quote:FC<QuoteProps> = () => {
  
  
  const quote = "Some people choose to see the ugliness in this world, the disarray. I choose to see the beauty."
  
  return (
      
    <div className={styles.quote}>
     <p> {quote}</p>
      <span>💖</span>
    </div>
  )
}

export default Quote;
